import { axios } from "../utils/request";

// 1.7.1.1 获取海报
export function getPosterPicVoList(data) {
  return axios({
    url: '/h5PosterPic/getPosterPicVoList',
    method: 'post',
    data
  })
}


// 获取用户二维码
export function getUserQrCode(data) {
  return axios({
    url: '/h5Share/getUserQrCode',
    method: 'post',
    data
  })
}

